import * as base64 from 'base-64';
import * as React from 'react';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import { translate } from 'secullum-i18n';
import { Details, Text } from 'secullum-react-native-ui';
import { getUrlApi } from '../modules/api';
import { carregarDadosLoginAsync } from '../modules/auth';
import { getTheme } from '../modules/layout';
import {
  AssinaturaDigitalCartaoPontoDados,
  TipoAlteracaoAssinaturaDigitalCartaoPonto
} from '../modules/types';

interface Props {
  assinaturaDigitalCartaoPonto: AssinaturaDigitalCartaoPontoDados;
  estado: TipoAlteracaoAssinaturaDigitalCartaoPonto | null;
  gerente?: boolean;
  onHabilitarScroll?: (habilitar: boolean) => void;
}

interface State {
  noContent: boolean;
  data: string;
  loadError: boolean;
}

class VisualizadorPdf extends React.Component<Props, State> {
  state: State = {
    noContent: false,
    data: '',
    loadError: false
  };

  async componentDidMount() {
    await this.carregarPdfAsync();
  }

  componentWillUnmount() {
    const { data } = this.state;

    if (data) {
      URL.revokeObjectURL(data);
    }
  }

  carregarPdfAsync = async () => {
    const dadosLogin = await carregarDadosLoginAsync();
    const { assinaturaDigitalCartaoPonto, gerente } = this.props;

    if (!dadosLogin || !dadosLogin.bancoId || !assinaturaDigitalCartaoPonto) {
      return;
    }

    const user = base64.encode(
      dadosLogin.funcionarioNumero +
        ':' +
        dadosLogin.funcionarioSenha +
        ':' +
        dadosLogin.tipoUsuarioAutenticacao
    );

    const urlApiBase = getUrlApi();

    const url =
      `${urlApiBase}${dadosLogin.bancoId}/AssinaturaDigitalCartaoPonto` +
      `/${assinaturaDigitalCartaoPonto.assinaturaDigitalCartaoPontoId}` +
      `${gerente ? `/${assinaturaDigitalCartaoPonto.funcionarioId}` : ''}` +
      `?axpw=${user}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        this.setState({ loadError: true });
        return;
      }

      const blob = await response.blob();

      if (blob.size === 0) {
        this.setState({ noContent: true });
        return;
      }

      this.setState({
        data: URL.createObjectURL(blob)
      });
    } catch {
      this.setState({ loadError: true });
    }
  };

  renderNoPreview = (message: string) => {
    return (
      <View style={[styles.container, styles.noPreview]}>
        <Text style={styles.noPreviewText}>{translate(message)}</Text>
      </View>
    );
  };

  renderPdfViewer = () => {
    if (this.state.noContent) {
      return this.renderNoPreview('Arquivo Excluído');
    }

    if (this.state.loadError) {
      return this.renderNoPreview('Erro ao carregar arquivo');
    }

    if (!this.state.data) {
      return (
        <View style={[styles.container, styles.loading]}>
          <ActivityIndicator color="#aaa" size="large" />
        </View>
      );
    }

    return (
      <View style={{ padding: 16 }}>
        <embed
          key={this.props.estado}
          src={this.state.data}
          style={{ maxWidth: 500, height: alturaPdf }}
        />
      </View>
    );
  };

  render() {
    return (
      <Details
        title={translate('Cartão Ponto')}
        lines={[{ render: this.renderPdfViewer }]}
      />
    );
  }
}

const theme = getTheme();
const alturaPdf = 761;

const styles = StyleSheet.create({
  container: {
    height: alturaPdf,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 16
  },
  noPreview: {
    borderWidth: 1,
    borderColor: theme.borderColor1
  },
  noPreviewText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'rgb(85, 85, 85)'
  },
  loading: {
    backgroundColor: theme.disabledColor
  }
});

export default VisualizadorPdf;
